import { NgModule } from '@angular/core';
import { LayoutComponent } from 'app/layout/layout.component';
import { CompactLayoutModule } from 'app/layout/layouts/vertical/compact/compact.module';
import {SharedModule} from "../shared/shared.module";


const layoutModules = [
    // Vertical navigation
    CompactLayoutModule,
];

@NgModule({
    declarations: [
        LayoutComponent
    ],
    imports     : [
        SharedModule,
        ...layoutModules,
    ],
    exports     : [
        LayoutComponent,
        ...layoutModules
    ]
})
export class LayoutModule
{
}
